import { c as _c } from "react/compiler-runtime";
import { InlineAlert } from '@onefootprint/ui';
import { useTranslation } from 'react-i18next';
import useEntitiesQueryParams, { EntityStatusFilter } from '@/components/entities/hooks/use-entities-query-params';
import { useEntitiesContext } from '@/entities/components/list/hooks/use-entities-context';
import useShouldShow from './hooks/use-should-show';
const Info = () => {
  const $0 = _c(11);
  let t0;
  if ($0[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      keyPrefix: "pages.entities.filters"
    };
    $0[0] = t0;
  } else {
    t0 = $0[0];
  }
  const {
    t
  } = useTranslation("common", t0);
  const {
    shouldShow,
    dismiss
  } = useShouldShow();
  const {
    values: t1
  } = useEntitiesQueryParams();
  const {
    state,
    verification,
    requiresManualReview
  } = t1;
  const context = useEntitiesContext();
  let t2;
  if ($0[1] !== context) {
    t2 = $ => $.kind[context.kind];
    $0[1] = context;
    $0[2] = t2;
  } else {
    t2 = $0[2];
  }
  let t3;
  if ($0[3] !== dismiss || $0[4] !== requiresManualReview || $0[5] !== shouldShow || $0[6] !== state || $0[7] !== t || $0[8] !== t2 || $0[9] !== verification) {
    const kind = t(t2);
    const getText = () => {
      if (requiresManualReview) {
        return t(_temp, {
          kind
        });
      }
      if (verification === EntityStatusFilter.none) {
        return t(_temp2, {
          kind
        });
      }
      if (verification === EntityStatusFilter.failed) {
        return t(_temp3, {
          kind
        });
      }
      if (verification === EntityStatusFilter.pass) {
        return t(_temp4, {
          kind
        });
      }
      if (state === EntityStatusFilter.incomplete) {
        return t(_temp5, {
          kind
        });
      }
      return t(_temp6, {
        kind
      });
    };
    t3 = shouldShow && (state || verification) ? <InlineAlert variant="info" cta={{
      label: t(_temp7),
      onClick: dismiss
    }}>{getText()}</InlineAlert> : null;
    $0[3] = dismiss;
    $0[4] = requiresManualReview;
    $0[5] = shouldShow;
    $0[6] = state;
    $0[7] = t;
    $0[8] = t2;
    $0[9] = verification;
    $0[10] = t3;
  } else {
    t3 = $0[10];
  }
  return t3;
};
export default Info;
function _temp($_0) {
  return $_0.info.manualReview;
}
function _temp2($_1) {
  return $_1.info.none;
}
function _temp3($_2) {
  return $_2.info.failed;
}
function _temp4($_3) {
  return $_3.info.pass;
}
function _temp5($_4) {
  return $_4.info.incomplete;
}
function _temp6($_5) {
  return $_5.info.complete;
}
function _temp7($_6) {
  return $_6.info.cta;
}